<man-pool-form
  [loading]="loading$ | asyncNotNull"
  [saving]="saving$ | asyncNotNull"
  [disabled]="disabled$ | asyncNotNull"
  [pool]="pool$ | asyncNotNull"
  (save)="onSave($event)"
  (stateChange)="onStateChange($event)"
></man-pool-form>
